import { CardType } from "./types/CardType";

export const cards: CardType[] = [
  {
    id: 1,
    color: "red",
    shape: "peanut",
    fill: "solid",
    quantity: 1,
    selected: false,
    set: null,
  },
  {
    id: 2,
    color: "red",
    shape: "peanut",
    fill: "solid",
    quantity: 2,
    selected: false,
    set: null,
  },
  {
    id: 3,
    color: "red",
    shape: "peanut",
    fill: "solid",
    quantity: 3,
    selected: false,
    set: null,
  },
  {
    id: 4,
    color: "purple",
    shape: "peanut",
    fill: "solid",
    quantity: 1,
    selected: false,
    set: null,
  },
  {
    id: 5,
    color: "purple",
    shape: "peanut",
    fill: "solid",
    quantity: 2,
    selected: false,
    set: null,
  },
  {
    id: 6,
    color: "purple",
    shape: "peanut",
    fill: "solid",
    quantity: 3,
    selected: false,
    set: null,
  },
  {
    id: 7,
    color: "green",
    shape: "peanut",
    fill: "solid",
    quantity: 1,
    selected: false,
    set: null,
  },
  {
    id: 8,
    color: "green",
    shape: "peanut",
    fill: "solid",
    quantity: 2,
    selected: false,
    set: null,
  },
  {
    id: 9,
    color: "green",
    shape: "peanut",
    fill: "solid",
    quantity: 3,
    selected: false,
    set: null,
  },
  {
    id: 10,
    color: "red",
    shape: "diamond",
    fill: "solid",
    quantity: 1,
    selected: false,
    set: null,
  },
  {
    id: 11,
    color: "red",
    shape: "diamond",
    fill: "solid",
    quantity: 2,
    selected: false,
    set: null,
  },
  {
    id: 12,
    color: "red",
    shape: "diamond",
    fill: "solid",
    quantity: 3,
    selected: false,
    set: null,
  },
  {
    id: 13,
    color: "purple",
    shape: "diamond",
    fill: "solid",
    quantity: 1,
    selected: false,
    set: null,
  },
  {
    id: 14,
    color: "purple",
    shape: "diamond",
    fill: "solid",
    quantity: 2,
    selected: false,
    set: null,
  },
  {
    id: 15,
    color: "purple",
    shape: "diamond",
    fill: "solid",
    quantity: 3,
    selected: false,
    set: null,
  },
  {
    id: 16,
    color: "green",
    shape: "diamond",
    fill: "solid",
    quantity: 1,
    selected: false,
    set: null,
  },
  {
    id: 17,
    color: "green",
    shape: "diamond",
    fill: "solid",
    quantity: 2,
    selected: false,
    set: null,
  },
  {
    id: 18,
    color: "green",
    shape: "diamond",
    fill: "solid",
    quantity: 3,
    selected: false,
    set: null,
  },
  {
    id: 19,
    color: "red",
    shape: "pill",
    fill: "solid",
    quantity: 1,
    selected: false,
    set: null,
  },
  {
    id: 20,
    color: "red",
    shape: "pill",
    fill: "solid",
    quantity: 2,
    selected: false,
    set: null,
  },
  {
    id: 21,
    color: "red",
    shape: "pill",
    fill: "solid",
    quantity: 3,
    selected: false,
    set: null,
  },
  {
    id: 22,
    color: "purple",
    shape: "pill",
    fill: "solid",
    quantity: 1,
    selected: false,
    set: null,
  },
  {
    id: 23,
    color: "purple",
    shape: "pill",
    fill: "solid",
    quantity: 2,
    selected: false,
    set: null,
  },
  {
    id: 24,
    color: "purple",
    shape: "pill",
    fill: "solid",
    quantity: 3,
    selected: false,
    set: null,
  },
  {
    id: 25,
    color: "green",
    shape: "pill",
    fill: "solid",
    quantity: 1,
    selected: false,
    set: null,
  },
  {
    id: 26,
    color: "green",
    shape: "pill",
    fill: "solid",
    quantity: 2,
    selected: false,
    set: null,
  },
  {
    id: 27,
    color: "green",
    shape: "pill",
    fill: "solid",
    quantity: 3,
    selected: false,
    set: null,
  },
  {
    id: 28,
    color: "red",
    shape: "peanut",
    fill: "striped",
    quantity: 1,
    selected: false,
    set: null,
  },
  {
    id: 29,
    color: "red",
    shape: "peanut",
    fill: "striped",
    quantity: 2,
    selected: false,
    set: null,
  },
  {
    id: 30,
    color: "red",
    shape: "peanut",
    fill: "striped",
    quantity: 3,
    selected: false,
    set: null,
  },
  {
    id: 31,
    color: "purple",
    shape: "peanut",
    fill: "striped",
    quantity: 1,
    selected: false,
    set: null,
  },
  {
    id: 32,
    color: "purple",
    shape: "peanut",
    fill: "striped",
    quantity: 2,
    selected: false,
    set: null,
  },
  {
    id: 33,
    color: "purple",
    shape: "peanut",
    fill: "striped",
    quantity: 3,
    selected: false,
    set: null,
  },
  {
    id: 34,
    color: "green",
    shape: "peanut",
    fill: "striped",
    quantity: 1,
    selected: false,
    set: null,
  },
  {
    id: 35,
    color: "green",
    shape: "peanut",
    fill: "striped",
    quantity: 2,
    selected: false,
    set: null,
  },
  {
    id: 36,
    color: "green",
    shape: "peanut",
    fill: "striped",
    quantity: 3,
    selected: false,
    set: null,
  },
  {
    id: 37,
    color: "red",
    shape: "diamond",
    fill: "striped",
    quantity: 1,
    selected: false,
    set: null,
  },
  {
    id: 38,
    color: "red",
    shape: "diamond",
    fill: "striped",
    quantity: 2,
    selected: false,
    set: null,
  },
  {
    id: 39,
    color: "red",
    shape: "diamond",
    fill: "striped",
    quantity: 3,
    selected: false,
    set: null,
  },
  {
    id: 40,
    color: "purple",
    shape: "diamond",
    fill: "striped",
    quantity: 1,
    selected: false,
    set: null,
  },
  {
    id: 41,
    color: "purple",
    shape: "diamond",
    fill: "striped",
    quantity: 2,
    selected: false,
    set: null,
  },
  {
    id: 42,
    color: "purple",
    shape: "diamond",
    fill: "striped",
    quantity: 3,
    selected: false,
    set: null,
  },
  {
    id: 43,
    color: "green",
    shape: "diamond",
    fill: "striped",
    quantity: 1,
    selected: false,
    set: null,
  },
  {
    id: 44,
    color: "green",
    shape: "diamond",
    fill: "striped",
    quantity: 2,
    selected: false,
    set: null,
  },
  {
    id: 45,
    color: "green",
    shape: "diamond",
    fill: "striped",
    quantity: 3,
    selected: false,
    set: null,
  },
  {
    id: 46,
    color: "red",
    shape: "pill",
    fill: "striped",
    quantity: 1,
    selected: false,
    set: null,
  },
  {
    id: 47,
    color: "red",
    shape: "pill",
    fill: "striped",
    quantity: 2,
    selected: false,
    set: null,
  },
  {
    id: 48,
    color: "red",
    shape: "pill",
    fill: "striped",
    quantity: 3,
    selected: false,
    set: null,
  },
  {
    id: 49,
    color: "purple",
    shape: "pill",
    fill: "striped",
    quantity: 1,
    selected: false,
    set: null,
  },
  {
    id: 50,
    color: "purple",
    shape: "pill",
    fill: "striped",
    quantity: 2,
    selected: false,
    set: null,
  },
  {
    id: 51,
    color: "purple",
    shape: "pill",
    fill: "striped",
    quantity: 3,
    selected: false,
    set: null,
  },
  {
    id: 52,
    color: "green",
    shape: "pill",
    fill: "striped",
    quantity: 1,
    selected: false,
    set: null,
  },
  {
    id: 53,
    color: "green",
    shape: "pill",
    fill: "striped",
    quantity: 2,
    selected: false,
    set: null,
  },
  {
    id: 54,
    color: "green",
    shape: "pill",
    fill: "striped",
    quantity: 3,
    selected: false,
    set: null,
  },
  {
    id: 55,
    color: "red",
    shape: "peanut",
    fill: "empty",
    quantity: 1,
    selected: false,
    set: null,
  },
  {
    id: 56,
    color: "red",
    shape: "peanut",
    fill: "empty",
    quantity: 2,
    selected: false,
    set: null,
  },
  {
    id: 57,
    color: "red",
    shape: "peanut",
    fill: "empty",
    quantity: 3,
    selected: false,
    set: null,
  },
  {
    id: 58,
    color: "purple",
    shape: "peanut",
    fill: "empty",
    quantity: 1,
    selected: false,
    set: null,
  },
  {
    id: 59,
    color: "purple",
    shape: "peanut",
    fill: "empty",
    quantity: 2,
    selected: false,
    set: null,
  },
  {
    id: 60,
    color: "purple",
    shape: "peanut",
    fill: "empty",
    quantity: 3,
    selected: false,
    set: null,
  },
  {
    id: 61,
    color: "green",
    shape: "peanut",
    fill: "empty",
    quantity: 1,
    selected: false,
    set: null,
  },
  {
    id: 62,
    color: "green",
    shape: "peanut",
    fill: "empty",
    quantity: 2,
    selected: false,
    set: null,
  },
  {
    id: 63,
    color: "green",
    shape: "peanut",
    fill: "empty",
    quantity: 3,
    selected: false,
    set: null,
  },
  {
    id: 64,
    color: "red",
    shape: "diamond",
    fill: "empty",
    quantity: 1,
    selected: false,
    set: null,
  },
  {
    id: 65,
    color: "red",
    shape: "diamond",
    fill: "empty",
    quantity: 2,
    selected: false,
    set: null,
  },
  {
    id: 66,
    color: "red",
    shape: "diamond",
    fill: "empty",
    quantity: 3,
    selected: false,
    set: null,
  },
  {
    id: 67,
    color: "purple",
    shape: "diamond",
    fill: "empty",
    quantity: 1,
    selected: false,
    set: null,
  },
  {
    id: 68,
    color: "purple",
    shape: "diamond",
    fill: "empty",
    quantity: 2,
    selected: false,
    set: null,
  },
  {
    id: 69,
    color: "purple",
    shape: "diamond",
    fill: "empty",
    quantity: 3,
    selected: false,
    set: null,
  },
  {
    id: 70,
    color: "green",
    shape: "diamond",
    fill: "empty",
    quantity: 1,
    selected: false,
    set: null,
  },
  {
    id: 71,
    color: "green",
    shape: "diamond",
    fill: "empty",
    quantity: 2,
    selected: false,
    set: null,
  },
  {
    id: 72,
    color: "green",
    shape: "diamond",
    fill: "empty",
    quantity: 3,
    selected: false,
    set: null,
  },
  {
    id: 73,
    color: "red",
    shape: "pill",
    fill: "empty",
    quantity: 1,
    selected: false,
    set: null,
  },
  {
    id: 74,
    color: "red",
    shape: "pill",
    fill: "empty",
    quantity: 2,
    selected: false,
    set: null,
  },
  {
    id: 75,
    color: "red",
    shape: "pill",
    fill: "empty",
    quantity: 3,
    selected: false,
    set: null,
  },
  {
    id: 76,
    color: "purple",
    shape: "pill",
    fill: "empty",
    quantity: 1,
    selected: false,
    set: null,
  },
  {
    id: 77,
    color: "purple",
    shape: "pill",
    fill: "empty",
    quantity: 2,
    selected: false,
    set: null,
  },
  {
    id: 78,
    color: "purple",
    shape: "pill",
    fill: "empty",
    quantity: 3,
    selected: false,
    set: null,
  },
  {
    id: 79,
    color: "green",
    shape: "pill",
    fill: "empty",
    quantity: 1,
    selected: false,
    set: null,
  },
  {
    id: 80,
    color: "green",
    shape: "pill",
    fill: "empty",
    quantity: 2,
    selected: false,
    set: null,
  },
  {
    id: 81,
    color: "green",
    shape: "pill",
    fill: "empty",
    quantity: 3,
    selected: false,
    set: null,
  },
];
